<template>
  <div class="typing-bubble">
      <div class="dots"></div>
  </div>
</template>

<script>
export default {
  name: 'UserIsTypingBubble',
}
</script>

<style scoped lang="scss">
.dots {
  width: 4px;
  height: 4px;
  border-radius: 5px;
  animation: dotTyping 1.5s infinite linear;
  transform: translateX(-4px)
}

@keyframes dotTyping {
  0% {
    box-shadow: 5px 0 0 0 #999, 11px 0 0 0 #999, 17px 0 0 0 #999;
  }
  20% {
    box-shadow: 5px -6px 0 0 #999, 11px 0 0 0 #999, 17px 0 0 0 #999;
  }
  40% {
    box-shadow: 5px 0 0 0 #999, 11px -6px 0 0 #999, 17px 0 0 0 #999;
  }
  60% {
    box-shadow: 5px 0 0 0 #999, 11px 0 0 0 #999, 17px -6px 0 0 #999;
  }
  80%, 100%{
    box-shadow: 5px 0 0 0 #999, 11px 0 0 0 #999, 17px 0 0 0 #999;
  }
}
</style>
